export default "__VITE_ASSET__7547a6c0__"